import { render, staticRenderFns } from "./TableAlt.vue?vue&type=template&id=3551caa3&scoped=true"
import script from "./TableAlt.vue?vue&type=script&lang=js"
export * from "./TableAlt.vue?vue&type=script&lang=js"
import style0 from "./TableAlt.vue?vue&type=style&index=0&id=3551caa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3551caa3",
  null
  
)

export default component.exports